import {
  Autocomplete,
  Button,
  Checkbox,
  Grid,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useParams } from "react-router";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { fetchAddresses } from "../invoice/productDetails";
import moment from "moment";
import EditWrap from "../commonComponent/editWrap";
import { generateChallanPrint } from "./challanPrint";

const dispatchMediumList = [{ label: "Onsite" }, { label: "self-calibration" }];

export default function EditChallan() {
  const params = useParams();
  const [companyName, setCompanyName] = useState(null);
  const [clientsOption, setClientsOption] = useState([]);
  const [clientsObj, setClientsObj] = useState([]);
  const [allAddress, setAllAddress] = useState([]);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [standardArr, setStandardArr] = useState([]);
  const [allstandardList, setAllStandardArrList] = useState([]);
  const [selectedStdIDs, setselectedStdIDs] = useState([]);
  const [editAccess, setEditAccess] = useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );
  const [letterHead, setLetterHead] = useState(true);

  const [challanDetails, setChallanDetails] = useState({
    dispatchMedium: "",
    outwardDate: "",
    expectedReturnDate: "",
    additionalAccessories: "",
    outChallanNo: "",
    standardtIds: [],
    purpose: "",
  });

  const refresh = () => window.location.reload(false);

  const updateSrfObject = (key, value) => {
    setChallanDetails((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getStandardList = () => {
    axiosWithToken
      .get(`${BASE_URL}standards?_where=(status,eq,1)`)
      .then((res) => {
        setAllStandardArrList(res.data);
        const standardList = res.data
          .filter((s) => s.standardName != null)
          .map((s) => ({
            id: s.id,
            label: s.standardName,
            stId: s.stId,
          }));
        setStandardArr(standardList);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const getClientList = () => {
    axiosWithToken
      .get(`${BASE_URL}clients?_where=(status,eq,1)`)
      .then((res) => {
        const clients = res.data.map((c) => ({
          label: `${c.id}, ${c.companyName}`,
        }));
        const tClientsObj = {};
        res.data.forEach((c) => (tClientsObj[c.id] = c));
        setClientsOption(res.data);
        setClientsObj(tClientsObj);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const debouncedFetchAddresses = async (addressIds, shippingAddressIds) => {
    setLoading(true);
    const newAddressArray = await fetchAddresses(
      addressIds,
      shippingAddressIds
    );
    setAllAddress(newAddressArray);
    setLoading(false);
  };

  const getChallanList = () => {
    const query = {
      query: `SELECT c.companyName, si.address, si.standardtIds, si.outChallanNo, si.additionalAccessories,si.dispatchMedium,si.purpose, si.outwardDate, si.expectedReturnDate, si.clientId FROM standardInOutChallan si JOIN clients c ON si.clientId = c.id WHERE si.id = ${params.id}`,
    };
    axiosWithToken
      .post(`${BASE_URL}dynamic`, query)
      .then((res) => {
        const data = res.data[0];
        setCompanyName(data.companyName);
        debouncedFetchAddresses(data.address, "");
        setChallanDetails({
          dispatchMedium: data.dispatchMedium,
          purpose: data.purpose || "",
          outChallanNo: data.outChallanNo,
          additionalAccessories: data.additionalAccessories,
          outwardDate: moment(data.outwardDate).format("YYYY-MM-DD") || "",
          expectedReturnDate:
            moment(data.expectedReturnDate).format("YYYY-MM-DD") || "",
          standardtIds:
            data.standardtIds
              ?.split(",")
              .map((id) => parseInt(id.trim(), 10)) || [],
        });
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong!");
        }
      });
  };

  const handleSubmit = () => {
    const url = BASE_URL;
    const payload = {
      ...(params.id == 0 && {
        clientId: companyName || null,
        address: address || null,
      }),
      dispatchMedium: challanDetails.dispatchMedium,
      purpose: challanDetails.purpose || null,
      outChallanNo: challanDetails.outChallanNo || null,
      outwardDate: challanDetails.outwardDate
        ? moment(challanDetails.outwardDate).format("YYYY-MM-DD")
        : null,
      expectedReturnDate: challanDetails.expectedReturnDate
        ? moment(challanDetails.expectedReturnDate).format("YYYY-MM-DD")
        : null,
      additionalAccessories: challanDetails.additionalAccessories || null,
      standardtIds: challanDetails.standardtIds.join(",") || null,
    };

    if (params.id == 0) {
      if (!companyName) return toast.error("Select Client!");
      if (!challanDetails.standardtIds.length)
        return toast.error("Select Standards!");
      if (!challanDetails.outwardDate)
        return toast.error("Select Outward Date!");

      axiosWithToken
        .post(`${url}standardInOutChallan`, payload)
        .then(() => {
          toast.success("Challan created successfully!");
          setTimeout(refresh, 500);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    } else {
      axiosWithToken
        .patch(`${url}standardInOutChallan/${params.id}`, payload)
        .then(() => {
          toast.success("Challan updated successfully!");
          setTimeout(refresh, 500);
        })
        .catch((error) => {
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong!");
          }
        });
    }
  };

  useEffect(() => {
    getClientList();
    getStandardList();
    if (params.id != 0) getChallanList();
  }, []);

  useEffect(() => {
    if (
      params.id == 0 ||
      !challanDetails?.standardtIds?.length ||
      !allstandardList?.length
    )
      return;

    const selectedStdData = allstandardList.filter((std) =>
      challanDetails.standardtIds.includes(std.id)
    );
    setselectedStdIDs(selectedStdData);
  }, [params.id, challanDetails?.standardtIds, allstandardList]);

  let generetepdfProps = {
    companyName,
    allAddress,
    challanDetails,
    letterHead,
    selectedStdIDs,
  };

  return (
    <EditWrap>
      <Typography variant="h6" component="h6" textAlign={"left"}>
        {params?.id != 0 ? "Edit" : "Create"} Challan
      </Typography>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {params.id != 0 ? (
            <TextField
              label="Client"
              size="small"
              disabled
              value={companyName || ""}
              fullWidth
              variant="outlined"
            />
          ) : (
            <Autocomplete
              size="small"
              options={clientsOption}
              getOptionLabel={(option) => `${option.id}, ${option.companyName}`}
              renderInput={(params) => <TextField {...params} label="Client" />}
              onChange={(event, value) => {
                if (value) {
                  debouncedFetchAddresses(
                    value?.address,
                    value?.shippingAddress
                  );
                  setCompanyName(parseInt(value.id));
                  setAddress(clientsObj[parseInt(value.id)].address);
                } else {
                  setCompanyName(null);
                  setAddress("");
                }
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          {allAddress?.length === 1 ? (
            <TextField
              value={allAddress[0]?.address}
              label="Address *"
              fullWidth
              variant="outlined"
              size="small"
              disabled
            />
          ) : (
            <Autocomplete
              disabled={params.id != 0}
              options={allAddress}
              size="small"
              getOptionLabel={(option) => option?.address}
              renderInput={(params) => (
                <TextField {...params} label="Address *" variant="outlined" />
              )}
              onChange={(event, value) => {
                setAddress(value?.id);
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            multiple
            size="small"
            options={standardArr}
            value={standardArr.filter((opt) =>
              challanDetails.standardtIds.includes(opt.id)
            )}
            disableCloseOnSelect
            getOptionLabel={(option) => option.label}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.stId}: {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Master EQP"
                placeholder="Select multiple Standards"
              />
            )}
            onChange={(event, value) => {
              updateSrfObject(
                "standardtIds",
                value.map((opt) => opt.id)
              );
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            label="Challan No"
            value={challanDetails.outChallanNo}
            size="small"
            fullWidth
            variant="outlined"
            onChange={(e) => updateSrfObject("outChallanNo", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            label="Dispatch Medium"
            value={challanDetails.dispatchMedium}
            size="small"
            fullWidth
            variant="outlined"
            onChange={(e) => updateSrfObject("dispatchMedium", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Autocomplete
            size="small"
            options={dispatchMediumList}
            value={challanDetails.purpose}
            renderInput={(params) => <TextField {...params} label="Purpose" />}
            onChange={(event, value) => {
              updateSrfObject("purpose", value?.label || "");
            }}
            disabled={params.id != 0}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="Outward Date"
              format="dd/MM/yyyy"
              value={
                challanDetails.outwardDate
                  ? new Date(challanDetails.outwardDate)
                  : null
              }
              onChange={(newValue) => {
                updateSrfObject("outwardDate", newValue);
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              slotProps={{ textField: { size: "small", fullWidth: true } }}
              label="Expected Return Date"
              format="dd/MM/yyyy"
              value={
                challanDetails.expectedReturnDate
                  ? new Date(challanDetails.expectedReturnDate)
                  : null
              }
              onChange={(newValue) => {
                updateSrfObject("expectedReturnDate", newValue);
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            label="Additional Accessories"
            value={challanDetails.additionalAccessories}
            size="small"
            fullWidth
            multiline
            minRows={3}
            maxRows={5}
            variant="outlined"
            onChange={(e) =>
              updateSrfObject("additionalAccessories", e.target.value)
            }
          />
        </Grid>
      </Grid>

      <br />
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "3rem",
        }}
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        >
          Cancel
        </Button>
        {params.id != 0 && (
          <>
            <Autocomplete
              size="small"
              sx={{ minWidth: "200px" }}
              options={[
                { id: 1, label: "With Letter Head" },
                { id: 2, label: "Without Letter Head" },
              ]}
              renderInput={(params) => (
                <TextField {...params} label="letterHead" />
              )}
              onInputChange={(event, newInputValue) => {
                if (
                  newInputValue === "With Letter Head" ||
                  newInputValue === ""
                ) {
                  setLetterHead(true);
                } else if (newInputValue === "Without Letter Head") {
                  setLetterHead(false);
                }
              }}
            />
            <Button
              variant="contained"
              size="small"
              onClick={() => generateChallanPrint(generetepdfProps)}
            >
              Print
            </Button>
          </>
        )}
        <Tooltip
          title={
            !(editAccess?.includes(1) || editAccess?.includes(0))
              ? "You don't have access"
              : ""
          }
        >
          <Button
            variant="contained"
            size="small"
            disabled={!(editAccess?.includes(1) || editAccess?.includes(0))}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Tooltip>
      </Toolbar>
    </EditWrap>
  );
}
